import AdminLayout from '@/components/admin/AdminLayout';
import { usePropertyInquiries, useUpdatePropertyInquiryStatus } from '@/hooks/usePropertyInquiries';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Phone, Mail } from 'lucide-react';
import { format } from 'date-fns';

const AdminPropertyInquiries = () => {
  const { data: inquiries } = usePropertyInquiries();
  const updateStatus = useUpdatePropertyInquiryStatus();

  return (
    <AdminLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Property Inquiries</h1>

        <div className="bg-card rounded-lg border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Date</TableHead>
                <TableHead>Name</TableHead>
                <TableHead>Contact</TableHead>
                <TableHead>Property</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {inquiries?.map((inquiry: any) => (
                <TableRow key={inquiry.id}>
                  <TableCell>{format(new Date(inquiry.created_at), 'MMM dd, yyyy')}</TableCell>
                  <TableCell className="font-medium">{inquiry.full_name}</TableCell>
                  <TableCell>
                    <div className="flex gap-2">
                      <a href={`tel:${inquiry.phone}`}>
                        <Button variant="ghost" size="icon">
                          <Phone className="h-4 w-4" />
                        </Button>
                      </a>
                      <a href={`mailto:${inquiry.email}`}>
                        <Button variant="ghost" size="icon">
                          <Mail className="h-4 w-4" />
                        </Button>
                      </a>
                    </div>
                  </TableCell>
                  <TableCell>{inquiry.properties?.title}</TableCell>
                  <TableCell>
                    <Badge variant="outline">{inquiry.inquiry_type}</Badge>
                  </TableCell>
                  <TableCell>
                    <Badge>{inquiry.status}</Badge>
                  </TableCell>
                  <TableCell>
                    {inquiry.status === 'pending' && (
                      <Button
                        size="sm"
                        onClick={() => updateStatus.mutate({ id: inquiry.id, status: 'contacted' })}
                      >
                        Mark Contacted
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminPropertyInquiries;
